// This file is generated.
export var version = '1.67.0';
//# sourceMappingURL=version.js.map